/**
 * GraphQL endpoint helpers
 */

import { runtimeConfig } from '../../util/runtimeConfig';

// Ant service endpoint
const apiBaseUrl = runtimeConfig.API_BASE_URL;

export function getGraphQLEndpoint(): string {
  return `${apiBaseUrl}/gql`;
}

export function getGraphQLAuthEndpoint(): string {
  return `${apiBaseUrl}/admin-user/login`;
}
